import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColorPickerDirective } from 'ngx-color-picker';
import { COLORS } from '@shared/utils/colors';

@Component({
  selector: 'chitin-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  imports: [ColorPickerDirective],
})
export class ChitinColorPickerComponent {
  @Input()
  value?: string | null;

  @Input()
  presetColors: string[] = [...COLORS.picker];

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();
}
